<template>
    <q-form class="row" ref="form">
        <q-input
            v-model="subject"
            outlined
            label="Subject"
            class="col-12 q-mb-sm"
            :rules="[
                (val) => (val && val.length > 0) || 'Please type something',
            ]"
        />
        <q-input
            v-model="message"
            outlined
            label="Message"
            class="col-12"
            autogrow
            :rules="[
                (val) => (val && val.length > 0) || 'Please type something',
            ]"
        />
    </q-form>
</template>

<script>
import { ref } from "@vue/reactivity";
import { onMounted } from "@vue/runtime-core";
import { BASE_PATH, emitter } from "@/main";
import axios from "axios";
import { useRouter } from "vue-router";
export default {
    setup() {
        const form = ref();
        const subject = ref();
        const message = ref();

        const router = useRouter();

        const sendMessage = async () => {
            try {
                const patient = JSON.parse(localStorage.getItem("USER"));
                const { data } = await axios.post(`${BASE_PATH}/compose-sms`, {
                    userId: patient.Id,
                    message: message.value,
                    parent: 0,
                    subject: subject.value,
                });
                router.push({ name: "Home" });
            } catch (err) {
                console.log("err")
            } finally {
            }
        };

        const composeMessage = () => {
            console.log("composeMessage");
            form.value
                .validate()
                .then((valid) => {
                    console.log(valid);
                    if (valid) {
                        sendMessage();
                    }
                })
                .catch((err) => {
                    console.log("err");
                });
        };

        onMounted(() => {
            emitter.on("compose-message", composeMessage);
        });

        return {
            subject,
            message,
            form,
        };
    },
};
</script>
